import { createSelector } from 'reselect';
import _ from 'lodash';

export const getSearchResults = state =>
  _.get(state, 'PointOfSaleState.lookUp.searchResults', []);

export const getMessage = state =>
  _.get(state, 'PointOfSaleState.lookUp.message', '');

// TODO https://stackoverflow.com/questions/44154116/lodash-how-to-groupby-except-undefined
export const getGroupedLookUpSearchResults = createSelector(
  [getSearchResults],
  searchResults => _.groupBy(searchResults, searchResult => searchResult.type)
);

export const getShowLookUp = state =>
  _.get(state, 'PointOfSaleState.lookUp.showLookUp', false);

export const getQuery = state =>
  _.get(state, 'PointOfSaleState.lookUp.query', {});

export const getShowLoading = state =>
  _.get(state, 'PointOfSaleState.lookUp.showLoading', false);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/state/selector.js